// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-column-settings {
  width: 560px;
  height: 600px;
  display: flex;
  flex-direction: column;
}
.dialog-column-settings__content {
  overflow: auto;
  padding-top: 0;
}
.dialog-column-settings__content .dl-collapse__panel, .dialog-column-settings__content .dl-collapse__header {
  width: 100%;
}
.dialog-column-settings__content .dl-collapse__arrow-wrapper_position_right {
  margin-left: auto;
}
.dialog-column-settings__header {
  padding: 32px 32px 10px;
}
.dialog-column-settings__title {
  display: flex;
  flex-direction: column;
}
.dialog-column-settings__dialog-title {
  margin-bottom: 10px;
}
.dialog-column-settings__subtitle {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: var(--g-color-text-secondary);
}
.dialog-column-settings .g-dialog-btn-close {
  margin-top: 8px;
}
.dialog-column-settings__freeze-settings {
  margin-bottom: 32px;
}
.dialog-column-settings__frozen-columns-input {
  width: 90px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogColumnSettings/DialogColumnSettings.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,cAAA;EACA,cAAA;AACR;AACQ;EAEI,WAAA;AAAZ;AAGQ;EACI,iBAAA;AADZ;AAKI;EACI,uBAAA;AAHR;AAMI;EACI,aAAA;EACA,sBAAA;AAJR;AAOI;EACI,mBAAA;AALR;AAQI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AANR;AASI;EACI,eAAA;AAPR;AAUI;EACI,mBAAA;AARR;AAWI;EACI,WAAA;AATR","sourcesContent":[".dialog-column-settings {\n  width: 560px;\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n}\n.dialog-column-settings__content {\n  overflow: auto;\n  padding-top: 0;\n}\n.dialog-column-settings__content .dl-collapse__panel, .dialog-column-settings__content .dl-collapse__header {\n  width: 100%;\n}\n.dialog-column-settings__content .dl-collapse__arrow-wrapper_position_right {\n  margin-left: auto;\n}\n.dialog-column-settings__header {\n  padding: 32px 32px 10px;\n}\n.dialog-column-settings__title {\n  display: flex;\n  flex-direction: column;\n}\n.dialog-column-settings__dialog-title {\n  margin-bottom: 10px;\n}\n.dialog-column-settings__subtitle {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--g-color-text-secondary);\n}\n.dialog-column-settings .g-dialog-btn-close {\n  margin-top: 8px;\n}\n.dialog-column-settings__freeze-settings {\n  margin-bottom: 32px;\n}\n.dialog-column-settings__frozen-columns-input {\n  width: 90px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
